import React from 'react';
import { Helmet } from 'react-helmet-async';
import { Link } from 'react-router-dom';
import { CheckCircle2 } from 'lucide-react';

const Priser = () => {
  const privateDocs = [
    "Årsopgørelse fra skattevæsenet",
    "Forskudsopgørelse fra skattevæsenet",
    "Seneste 3 lønsedler",
    "Budgetskema",
    "Den fulde rapport fra www.pensionsinfo.dk",
    "Seneste årsopgørelser fra pensionskasser",
    "Oversigt over bankengagementer",
    "Depotoversigter fra bank/pensionskasse",
    "Restgældsoplysninger på realkreditlån",
    "Restgældsoplysninger samt oplysninger omkring ydelse og rentesats på øvrige lån/kreditter",
    "Oplysninger om navn og fødselsdato på børn",
    "Oplysninger omkring værdien af aktiver (fast ejendom, bil, båd m.m.)"
  ];

  const businessDocs = [
    "Seneste 3 års regnskaber",
    "Seneste periodebalance",
    "Budget for indeværende år",
    "Eventuelle debitor og kreditorliste"
  ];

  return (
    <div className="py-16 bg-white">
      <Helmet>
        <title>Priser: Rigtig pris for uvildig økonomisk rådgivning</title>
        <meta name="description" content="Vi starter med et gratis og uforpligtende møde hvor vi finder den rigtige pris til dit rådgivningsforløb. Prisen tilpasses nemlig dit behov. Se mere her" />
      </Helmet>

      <div className="container mx-auto px-4 max-w-4xl">
        <nav className="text-sm text-slate-500 mb-8 flex items-center space-x-2">
          <Link to="/" className="hover:text-[#b60f00]">Forsiden</Link>
          <span>/</span>
          <span className="text-slate-900 font-medium">Priser for økonomisk rådgivning og bistand</span>
        </nav>

        <h1 className="text-3xl md:text-4xl font-extrabold text-slate-900 mb-10 break-words">Priser for økonomisk rådgivning og bistand</h1>

        <div className="prose prose-slate prose-lg max-w-none mb-12">
          <h4 className="text-xl font-bold text-slate-900 mb-4">Økonomisk rådgivning til fordelagtige priser</h4>
          <p>
            Kontakt os for at indhente et tilbud på dit rådgivningsforløb. Vores timepris ligger på kr. 1.625 inklusive moms. Lad os få en snak om dine ønsker og behov, så vi kan lave den helt rigtige pris til dig.
          </p>
        </div>

        <div className="flex flex-col sm:flex-row gap-4 mb-16">
          <Link 
            to="/kontakt-os" 
            className="flex-1 bg-[#b60f00] text-white text-center px-6 py-4 rounded-xl font-bold hover:bg-[#a00d00] transition-all shadow-md"
          >
            Indhent tilbud
          </Link>
          <Link 
            to="/kontakt-os" 
            className="flex-1 bg-slate-100 text-slate-900 text-center px-6 py-4 rounded-xl font-bold hover:bg-slate-200 transition-all"
          >
            Book et gratis og uforpligtende møde
          </Link>
        </div>

        <div className="prose prose-slate prose-lg max-w-none mb-12">
          <p>
            Måske er du i tvivl om, hvorvidt uvildig økonomisk rådgivning er noget for dig, hvad det kommer til at koste, og hvor meget du kan spare. Vi tilbyder derfor helt uforpligtende, et gratis indledende møde, for at sikre at vi skaber værdi for dig og din familie.
          </p>
          <p>
            Vi vil gerne være så forberedte som muligt. Når vi mødes er der ingen grund til at spilde tid. Derfor beder vi dig sende en række dokumenter, som din rådgiver bruger i sin forberedelse til mødet. På den måde kan vi gå direkte igang med en komplet gennemgang af din økonomi når vi ses. Du kan se listen herunder.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-12 mb-12">
          <div className="bg-slate-50 rounded-3xl p-8 border border-slate-200">
            <h2 className="text-2xl font-bold text-slate-900 mb-6">
              Privatkunder:
            </h2>
            <ul className="space-y-3">
              {privateDocs.map((doc, i) => (
                <li key={i} className="flex items-start text-sm">
                  <CheckCircle2 size={16} className="text-[#b60f00] mr-3 shrink-0 mt-0.5" />
                  <span className="text-slate-700">{doc}</span>
                </li>
              ))}
            </ul>
          </div>

          <div className="space-y-8">
            <div className="bg-slate-50 rounded-3xl p-8 border border-slate-200">
              <h2 className="text-2xl font-bold text-slate-900 mb-6">
                Samt for erhvervskunder:
              </h2>
              <ul className="space-y-3">
                {businessDocs.map((doc, i) => (
                  <li key={i} className="flex items-start text-sm">
                    <CheckCircle2 size={16} className="text-[#b60f00] mr-3 shrink-0 mt-0.5" />
                    <span className="text-slate-700">{doc}</span>
                  </li>
                ))}
              </ul>
            </div>
            
            <div className="p-6 italic text-slate-500 text-sm border-l-4 border-slate-200">
              Ved besvarelse af enkeltspørgsmål aftales det fra gang til gang, hvilke dokumenter der skal fremsendes.
            </div>
          </div>
        </div>

        <div className="text-center text-slate-600">
          Du kan læse mere om vores rådgivning på de enkelte faneblade.
        </div>
      </div>
    </div>
  );
};

export default Priser;
